<template>
  <div class="hello">
    <div class="md-layout md-head-layout">
      <div class="md-layout-item md-small-size-100">
        <h1 class="calcHead" style="margin-bottom: 2px !important; margin-top: 17px !important;"> 
          CALCULA, REDUCE Y NEUTRALIZA 
        </h1>
        <h1 class="calcHead" style="color: #707070; margin-top: 2px !important;">TU HUELLA</h1>
        <div>
          <p class="headPara landing-para" style="text-align: justify;"><strong>Certificamos empresas, productos y eventos sustentables..</strong> <br /> Cada vez que un cliente escoge tus servicios o productos certificados, está ayudando al medio ambiente.</p>
        </div>
        <div class="md-layout sellos-seccion">
          <div class="md-layout-item text-sellos md-small-size-100"><span style="color:#00d371;">Escoge</span> tu sello</div>
          <div class="md-layout-item md-small-size-50 grow">
            <router-link to="/huelladecarbono" style="color: #707070;">
               <img src="@/assets/CARBON-FOOTPRINT.png" alt="huella de carbono">
               <p class="huella-item">Huella de Carbono</p>
            </router-link>
          </div>
          <div class="md-layout-item md-small-size-50 grow slide">
            <router-link to="/carbonoNeutral" style="color: #707070;">
              <img src="@/assets/CARBON-NEUTRAL-PRODUCT.png" alt="huella carbono nuetral">
              <p class="huella-item">Carbono Neutral</p>
            </router-link>
          </div>
          <div class="md-layout-item md-small-size-50 grow" v-if="weAreInCl">
            <router-link to="/huellaChile" style="color: #707070;">
              <img src="@/assets/huella.png" alt="huella chile calculo">
              <p class="huella-item">HuellaChile</p>
            </router-link>
          </div>
          <div class="md-layout-item md-small-size-50 grow slide">
            <router-link to="/huelladeagua" style="color: #707070;">
              <img src="@/assets/WATER-FOOTPRINT.png"  alt="huella de agua, desgate">
              <p class="huella-item ">Huella del Agua</p>
            </router-link>
          </div>
        </div>
      </div>
      
      <div class="md-layout-item right-side-head md-small-hide">
        <img alt="vaso" src="@/assets/vaso3.png" srcset=""  style="margin-top: -6vw; width: 60%">
         <ul class="chart-skills" style="display: none">
          <li>
            <span class="circleLow"></span>
          </li>
          <li>
            <span class="circleLow"></span>
          </li>
          <li>
            <span class="circleLow"></span>
          </li>
          <li>
            <span class="circleLow"></span>
          </li>
        </ul>
      </div>
      
    </div>
    <FirstSection />
    <div id="clients" style="padding-top: 2vw">
      <Clients />
    </div>
    <Trazado />
    <SecondSection />
  </div>
</template>

<script>
import FirstSection from './firstSection.vue'
import Clients from './Clients.vue'
import Trazado from './Trazado.vue'
import SecondSection from './secondSection.vue'

export default {
  components: {FirstSection, Clients, Trazado, SecondSection},
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data () {
    return {
      weAreInCl: true
    }
  },
  created () {
    if (window.location.origin === 'http://greensolutions.com.ar' || window.location.origin === 'https://greensolutions.com.ar'){
      this.weAreInCl = false
    }
  },
  methods: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .grow { transition: all .4s ease-in-out; }
  .grow:hover { transform: scale(1.2); }


.huella-item {
  font-size: 1vw;
  text-align: center;
}

.head-right-image {
  width: 94%;
  margin-right: 1rem;

}
.text-sellos {
  font-size: 1.1vw;
  padding-top: 2rem;
  text-align: justify;
}
.sellos-seccion {
  margin-top: 3vw
}

.sellos-seccion img {
  width: 60%;
  height: 60%;
}
.calcHead {
  font-size: 4vw;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.24;
  letter-spacing: -1.44px;
  text-align: left;
  color: #00d371;
}
.headPara {
  font-size: 1.4vw;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.65;
  letter-spacing: -0.52px;
  text-align: left;
  color: #707070;
}
 .md-head-layout {
   margin: 1vw 1vw 3vw 7vw;
 }  

/* semicircle */

.chart-skills {
  margin: 0 auto;
  padding: 0;
  list-style-type: none;
  margin-top: 1.2rem;
  margin-right: 6.9rem;

}

.chart-skills *,
.chart-skills::before {
  box-sizing: border-box;
}
.circleLow {
  height: 40px;
  width: 40px;
  background-color: #00d371;
  border-radius: 100%;
}

/* CHART-SKILLS STYLES
–––––––––––––––––––––––––––––––––––––––––––––––––– */

.chart-skills {
  position: relative;
  width: 600px;
  height: 300px;
  overflow: hidden;
}

.chart-skills::before,
.chart-skills::after {
  position: absolute;
}


.chart-skills::after {
  content: 'Top Skills';
  left: 50%;
  bottom: 10px;
  transform: translateX(-50%);
  font-size: 1.1rem;
  font-weight: bold;
  color: cadetblue;
}

.chart-skills li {
  position: absolute;
  top: 100%;
  left: 0;
  width: inherit;
  height: inherit;
  border: 4px dotted;
  border-top: none;
  border-bottom-left-radius: 300px;
  border-bottom-right-radius: 300px;
  transform-origin: 50% 0;
  transform-style: preserve-3d;
  backface-visibility: hidden;
  animation-fill-mode: forwards;
  animation-duration: .4s;
  animation-timing-function: linear;
}

.chart-skills li:nth-child(1) {
  z-index: 4;
  border-color: #00d371;
  animation-name: rotate-one;
}

.chart-skills li:nth-child(2) {
  z-index: 3;
  border-color: #00d371;
  animation-name: rotate-two;
  animation-delay: .4s;
}

.chart-skills li:nth-child(3) {
  z-index: 2;
  border-color: #00d371;
  animation-name: rotate-three;
  animation-delay: .8s;
}

.chart-skills li:nth-child(4) {
  z-index: 1;
  border-color: #00d371;
  animation-name: rotate-four;
  animation-delay: 1.2s;
}

.chart-skills span {
  position: absolute;
  font-size: .85rem;
  backface-visibility: hidden;
  animation: fade-in .4s linear forwards;
}

.chart-skills li:nth-child(1) span {
  top: 5px;
  left: 10px;
  transform: rotate(-21.6deg);
}

.chart-skills li:nth-child(2) span {
  top: 20px;
  left: 10px;
  transform: rotate(-79.2deg);
  animation-delay: .4s;
}

.chart-skills li:nth-child(3) span {
  top: 18px;
  left: 10px;
  transform: rotate(-140.4deg);
  animation-delay: .8s;
}

.chart-skills li:nth-child(4) span {
  top: 10px;
  left: 10px;
  transform: rotate(-180deg);
  animation-delay: 1.2s;
}


/* ANIMATIONS
–––––––––––––––––––––––––––––––––––––––––––––––––– */

@keyframes rotate-one {
  100% {
    transform: rotate(21.6deg);
    /**
     * 12% => 21.6deg
     */
  }
}

@keyframes rotate-two {
  0% {
    transform: rotate(21.6deg);
  }
  100% {
    transform: rotate(79.2deg);
    /**
     * 32% => 57.6deg 
     * 57.6 + 21.6 => 79.2deg
     */
  }
}

@keyframes rotate-three {
  0% {
    transform: rotate(79.2deg);
  }
  100% {
    transform: rotate(140.4deg);
    /**
     * 34% => 61.2deg 
     * 61.2 + 79.2 => 140.4deg
     */
  }
}

@keyframes rotate-four {
  0% {
    transform: rotate(140.4deg);
  }
  100% {
    transform: rotate(180deg);
    /**
     * 22% => 39.6deg  
     * 140.4 + 39.6 => 180deg
     */
  }
}

@keyframes fade-in {
  0%,
  90% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}


</style>
